import { BsDot } from "react-icons/bs";
import { FaAngleRight } from "react-icons/fa";
import { Link } from "react-router-dom";

const Listitem = ({
  itemname,
  className,
  href,
  title,
  isArrow,
  time,
  dot,
  subCategory,
}) => {
  return (
    <li className={`relative ${className}`}>
      <div className="flex items-center">
        {dot && <BsDot />}
        {title}
      </div>
      <div className="flex items-center justify-between">
        <Link to={href}>{itemname}</Link>
        {isArrow && <FaAngleRight />}
        {time}
      </div>
    </li>
  );
};

export default Listitem;
